import React from 'react';
import { Icon } from '../icon/Icon.jsx';

/* Order IDs, tx hashes, wallet and contract addresses, program IDs.
   ALWAYS full, never truncated, never elided — where horizontal space is short
   it WRAPS. Address substitution is a real attack and an ellipsis is how it
   gets missed. */

export function CopyableId({ value, explorerHref, explorerLabel = 'explorer', style }) {
  const [copied, setCopied] = React.useState(false);
  const copy = () => {
    try { navigator.clipboard.writeText(value); } catch (e) { /* no-op */ }
    setCopied(true); setTimeout(() => setCopied(false), 1200);
  };
  return (
    <span className="jmt-copyid" style={{ display: 'inline-flex', alignItems: 'baseline', gap: 'var(--space-8)', maxWidth: '100%', ...style }}>
      <code style={{
        fontFamily: 'var(--font-mono)', fontSize: 'var(--code-size)', lineHeight: 'var(--code-line)',
        color: 'var(--text-primary)', overflowWrap: 'anywhere', wordBreak: 'break-all',
      }}>{value}</code>
      <button type="button" onClick={copy} title={copied ? 'Copied' : 'Copy'} className="jmt-copybtn"
        style={{ background: 'none', border: 'none', padding: 2, cursor: 'pointer', color: 'var(--text-tertiary)', opacity: copied ? 1 : 0, transition: 'opacity var(--dur-state) linear' }}>
        <Icon name={copied ? 'check' : 'copy'} size={14} />
      </button>
      {explorerHref ? (
        <a href={explorerHref} style={{ fontSize: 'var(--caption-size)', whiteSpace: 'nowrap' }}>{explorerLabel}</a>
      ) : null}
      <style>{`.jmt-copyid:hover .jmt-copybtn,.jmt-copybtn:focus-visible{opacity:1}`}</style>
    </span>
  );
}
